import { render, staticRenderFns } from "./company-achieve-update.vue?vue&type=template&id=5b1a1901&scoped=true"
import script from "./company-achieve-update.vue?vue&type=script&lang=ts"
export * from "./company-achieve-update.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a1901",
  null
  
)

export default component.exports